export default __webpack_public_path__ + "static/VCR_OSD_MONO_1.001-10cf96d54dcd9af0486c71a6b5017abd.ttf";